import { Fragment, useState } from "react";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../modal/Dialog";
import { Button } from "@sellar-io/components";
import { SupplierRelationshipListResponseType } from "@sellar-io/api-v2/types";
import { twMerge } from "tailwind-merge";
import { getDiscountDescription } from "./ConvertDiscountsWarningDialog.shared";

export function ConvertDiscountsWarningDialog({
  active,
  onDismiss,
  onConfirm,
  connections,
}: {
  active: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  connections: SupplierRelationshipListResponseType;
}) {
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      {active && (
        <Content
          onConfirm={onConfirm}
          onDismiss={onDismiss}
          connections={connections}
        />
      )}
    </Dialog>
  );
}

const Content = ({
  onConfirm,
  onDismiss,
  connections,
}: {
  onConfirm: () => void;
  onDismiss: () => void;
  connections: SupplierRelationshipListResponseType;
}) => {
  const [confirm, setConfirm] = useState(false);

  return (
    <>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title="Replace customer-level discounts?"
        description="The discounts you've configured as part of this price list will replace the discounts set directly on the customer"
      />
      <DialogContent className="flex flex-col gap-8">
        <div className="grid grid-cols-2 rounded-lg border border-zinc-300 text-sm">
          <span className="rounded-tl-lg border-r border-b border-zinc-300 bg-zinc-50 px-3 py-2 font-semibold">
            Customer
          </span>
          <span className="rounded-tr-lg border-b border-zinc-300 bg-zinc-50 px-3 py-2 font-semibold">
            Customer-level discounts
          </span>

          {connections.map((connection, idx) => (
            <Fragment key={connection.id}>
              <span
                className={twMerge(
                  "border-r border-zinc-300 px-3 py-2",
                  idx !== connections.length - 1 && "border-b",
                )}
              >
                {connection.Buyer.Business.name}
              </span>
              <span
                className={twMerge(
                  "border-zinc-300 px-3 py-2",
                  idx !== connections.length - 1 && "border-b",
                )}
              >
                {getDiscountDescription(connection)}
              </span>
            </Fragment>
          ))}
        </div>

        <div
          className="flex cursor-pointer items-center gap-2 rounded-lg border border-blue-300 bg-blue-100 px-3 py-2 font-semibold hover:border-blue-500"
          onClick={() => setConfirm(!confirm)}
        >
          <input
            checked={confirm}
            readOnly
            type="radio"
            className="h-4 w-4 appearance-none rounded-full border-2 border-gray-800 text-black checked:border-[6px] checked:bg-white"
          />
          I confirm I want to replace this customer discounts with this price
          list
        </div>
      </DialogContent>

      <DialogCTA>
        <Button color="transparent" onClick={onDismiss}>
          Go back to customer selection
        </Button>
        <Button disabled={!confirm} onClick={onConfirm}>
          Confirm
        </Button>
      </DialogCTA>
    </>
  );
};
